import React, { useState } from "react";
import { Container, Input } from "../styled.ts";
import { debounce } from "../../utils/debounce.js";
import { CrossIcon, FilterIcon } from "../icons/index.tsx";

export const Filter = ({
  placeholder = "enter something",
  padding = "2px 3px",
  onChange = (val) => {
    console.log(val);
  },
}) => {
  const DELAY = 500;
  const [searchKey, setSearchKey] = useState("");
  const debouncedOnChange = debounce(onChange, DELAY);
  const [isFilterActive, setIsFilterActive] = useState(false);

  return (
    <Container
      padding={padding}
      border="1px solid #EEEEEE"
      radius="100px"
      background="#FAFAFA"
      alignItems="center"
    >
      {isFilterActive && (
        <Input
          type="text"
          placeholder={placeholder}
          border="none"
          value={searchKey}
          height={"15px"}
          color="#828282"
          width="max(200px , calc(100% - 50px))"
          onChange={(e) => {
            debouncedOnChange(e.target.value);
            setSearchKey(e.target.value);
          }}
        />
      )}
      <Container >
        {!!searchKey ? (
          <CrossIcon
            width="12"
            height="12"
            color={"#828282"}
            onClick={() => {
              onChange("");
              setSearchKey("");
            }}
          />
        ) : (
          <FilterIcon
            width="12"
            height="12"
            color={"#828282"}
            onClick={() => {
              setIsFilterActive(!isFilterActive);
            }}
          />
        )}
      </Container>
    </Container>
  );
};
